<template>
  <body>
    <div class="software-container">
      <h2>Image Inverter</h2>
      <p class="header">
        Cross-platform desktop app for transforming images into abstract art
      </p>
      <span>Github: <a href="https://github.com/m-nccloud/ImageInverter">https://github.com/m-nccloud/ImageInverter</a></span>
      <p class="example-pics">
        Example pictures (click to enlarge):
      </p>
      <div class="image-viewer-container">
        <img
          v-if="!mobile"
          class="image-viewer"
          :src="require(`@/assets/images/software_projects/img_inverter/${imgIdx}.png`)"
          @click="$emit('enlargeImage', imgIdx)"
        >
        <div
          v-if="!mobile"
          class="chevron-container"
        >
          <p
            :class="imgEnlarged ? 'chevron-enlarged' : ''"
            class="chevron"
            @click="advanceIndex(true)"
          >
            &#8672;
          </p>
          <!-- <p>&#9670;</p> -->
          <p
            class="chevron"
            :class="imgEnlarged ? 'chevron-enlarged' : ''"
            @click="advanceIndex(false)"
          >
            &#8674;
          </p>
        </div>
        <div
          v-if="mobile"
          class="chevron-container"
        >
          <p
            class="chevron-mobile"
            @click="advanceIndex(true)"
          >
            &#8672;
          </p>
          <p
            class="chevron-mobile"
            @click="advanceIndex(false)"
          >
            &#8674;
          </p>
        </div>
        <a
          :href="require(`@/assets/images/software_projects/img_inverter/${imgIdx}.png`)" 
          target="_blank"
        >
          <img
            v-if="mobile"
            class="image-viewer"
            :src="require(`@/assets/images/software_projects/img_inverter/${imgIdx}.png`)"
            @click="$emit('enlargeImage', imgIdx)"
          >
        </a>
      </div>
    </div>
  </body>
</template>

<script setup>
import { ref } from "vue";

const numImgs = 6;
const imgIdx = ref(0);
const advanceIndex = (reverse) => {
  imgIdx.value += (reverse ? -1 : 1);
  if(imgIdx.value == numImgs) imgIdx.value = 0;
  else if(imgIdx.value == -1) imgIdx.value = numImgs - 1;
  emit('changeImgIdx', imgIdx.value);
}

const props = defineProps({
  mobile: {
    type: Boolean,
    default: false
  },
  imgEnlarged: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['enlargeImage', 'changeImgIdx']);
</script>
  

<style lang="scss" scoped>
$sm: 540px;
$md: 720px;
$lg: 960px;
$xl: 1140px;

.header {
  margin-bottom: 0px;
}

.example-pics {
  @media(max-width: $md) {
    margin-bottom: 0px;
  }
  @media(min-width: $md) {
    margin-top: 20px;
  }
    // margin-left: -30rem;
}

span {
  @media(min-width: $md){
    margin-left: -15rem;
  }
}

.image-viewer {
    margin-top: -19px;
    max-height: 40vh;
    max-width: 65vw;
    @media(min-width: $md) and (-webkit-min-device-pixel-ratio: 1), (min-resolution: 1dppx), (min-resolution: 100dpi) {
      max-height: 50vh;
    }
    @media(min-width: $md) and (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 1.25dppx), (min-resolution: 120dpi) {
      max-height: 35vh;
    }
    cursor: pointer;
}

.chevron-container {
  display: flex;
  justify-content: center;
}

.chevron,
.chevron-mobile {
  font-size: 2.3rem;
  cursor: pointer;
  z-index: 103;
}

.chevron {
  // margin-bottom: -10px;
  margin-top: -1.35rem;
  font-size: 3rem;
}

.chevron:hover {
  opacity: .5;
}

.chevron-enlarged {
  background-color: black;
  line-height: 35px;
}

.software-container {
  border: .75px dashed gray;
}

</style>  
  